import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { type TextAreaHookOptions } from '@pkg/primitives';

import { Skeleton, SkeletonLabel, StaticLabel, StyledUserBio } from './UserBio.style';

export interface UserBioStaticProps {
    value?: TextAreaHookOptions['initialValue'];
    loading?: boolean;
}

export function UserBioStatic({ value, loading = false }: UserBioStaticProps) {
    const safeValue = value || '…';

    const skeletonMarkup = loading ? (
        <Skeleton key="UserBioStatic-Skeleton">
            <SkeletonLabel />
        </Skeleton>
    ) : null;

    return (
        <StyledUserBio>
            <StaticLabel $loading={loading}>{safeValue}</StaticLabel>
            <AnimatePresence>{skeletonMarkup}</AnimatePresence>
        </StyledUserBio>
    );
}
